import React, { useState } from 'react';
import { X } from 'lucide-react';
import { JobsCTA } from './components/JobsCTA';
import { Footer } from './components/Footer';
import { Navigation, ServiceType } from './components/Navigation';
import { OrderForm } from './components/OrderForm';
import { BookTableModal } from './components/BookTableModal';
import { Home } from './pages/Home';
import { Events } from './pages/Events';
import { usePath } from './hooks/usePath';
import { HalloweekBanner } from './components/HalloweekBanner';
export function App() {
  const {
    path,
    navigate
  } = usePath();
  const isEvents = path === '/events';
  const [selectedService, setSelectedService] = useState<ServiceType | null>(null);
  const [showJobs, setShowJobs] = useState(false);
  const [showBookTable, setShowBookTable] = useState(false);
  const [businessOrderTrigger, setBusinessOrderTrigger] = useState(0);

  // From a sub-page, return to the start page before scrolling to the catalog
  const withHome = (action: () => void) => {
    if (isEvents) {
      navigate('/');
      setTimeout(action, 60);
    } else {
      action();
    }
  };
  const scrollToCatalog = () => document.getElementById('catalog')?.scrollIntoView({
    behavior: 'smooth'
  });
  const handleScrollToCatalog = () => withHome(scrollToCatalog);
  const handleBusinessOrder = () => withHome(() => {
    scrollToCatalog();
    setBusinessOrderTrigger(prev => prev + 1);
  });
  return <div className={`min-h-screen w-full font-sans selection:bg-[#7C8062] selection:text-white flex flex-col transition-colors duration-200 ${isEvents ? 'bg-[#0E0C0B] text-[#F5EDE3]' : 'bg-[#F2EDE4] text-[#1A1A1A]'}`} data-id="element-0" data-mp="2zmem63p09c5e">
      {!isEvents && <HalloweekBanner onOpen={() => navigate('/events')} data-id="element-1" data-mp="3dkuwe4m2tksa" />}
      <Navigation onOrderClick={type => setSelectedService(type)} onJobsClick={() => setShowJobs(true)} onBusinessOrder={handleBusinessOrder} onScrollToCatalog={handleScrollToCatalog} onEventsClick={() => navigate('/events')} isEventsActive={isEvents} data-id="element-2" data-mp="3dmfozootytni" />

      <main className="flex-grow flex flex-col items-center w-full" data-id="element-3" data-mp="34ndtz6vvc0b">
        {isEvents ? <Events onBack={() => navigate('/')} data-id="element-4" data-mp="3ucjdpx58qhvb" /> : <Home onScrollToCatalog={handleScrollToCatalog} onBusinessOrder={handleBusinessOrder} onBookTable={() => setShowBookTable(true)} onJobs={() => setShowJobs(true)} onOrderClick={type => setSelectedService(type)} onHalloweek={() => navigate('/events')} businessOrderTrigger={businessOrderTrigger} data-id="element-5" data-mp="d4xlz5e29t8m" />}
      </main>

      <Footer dark={isEvents} data-id="element-6" data-mp="3qcr0h74wjnjm" />

      {selectedService && <OrderForm type={selectedService} onClose={() => setSelectedService(null)} data-id="element-7" data-mp="3ljxuyh1m0b6h" />}

      {showBookTable && <BookTableModal onClose={() => setShowBookTable(false)} data-id="element-8" data-mp="2xt2ak4zhgi99" />}

      {/* Jobs Page Overlay */}
      {showJobs && <div className="fixed inset-0 z-50 bg-[#F2EDE4] overflow-y-auto" data-id="element-9" data-mp="18drk5y5ejjev">
          <div className="sticky top-0 z-10 bg-[#F2EDE4] border-b border-[#7C8062]/15 shadow-sm" data-id="element-10" data-mp="18boigguw01ub">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between h-14" data-id="element-11" data-mp="1d6kmkfdeefns">
              <button onClick={() => setShowJobs(false)} className="flex items-center gap-2 text-sm font-medium text-[#1A1A1A]/70 hover:text-[#7C8062] transition-colors" data-id="element-12" data-mp="ydqulugxw728">
                ← Tillbaka
              </button>
              <h1 className="text-lg font-serif text-[#1A1A1A]" data-id="element-13" data-mp="1w2tyox4qow55">
                Jobba hos oss
              </h1>
              <button onClick={() => setShowJobs(false)} className="p-2 text-[#1A1A1A]/50 hover:text-[#1A1A1A] hover:bg-[#7C8062]/10 rounded-full transition-colors" aria-label="Stäng" data-id="element-14" data-mp="1i3b4l88rjlbu">
                <X className="w-5 h-5" data-id="element-15" data-mp="aqistmipzg4y" />
              </button>
            </div>
          </div>
          <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-16" data-mp="qxnlxln52ev2">
            <JobsCTA data-id="element-17" data-mp="qyyltadgr2gw" />
          </div>
        </div>}
    </div>;
}